module.exports = __webpack_public_path__ + "media/images/star_off-f968c41eaeb7ac0923b77e8987494980.png";